import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { toggleModal } from 'apps/auth/actions/appAction';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';

const PaymentPendingModal = (props) => {
    return (
        <ModalComponent canCloseModal={false}>
            <InfoPage
                insideModalComponent
                animatedIconSuccess
                primaryButtonType="button"
                primaryButtonCaption={props.gotIt}
                primaryButtonOnClick={() => {
                    props.toggleModal(false);
                }}
                mainText={props.text}
            />
        </ModalComponent>
    );
};

PaymentPendingModal.propTypes = {
    text: PropTypes.string,
    gotIt: PropTypes.string,
};

export default connect(null, { toggleModal })(PaymentPendingModal);
